<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
	<h6 mat-dialog-title>
		{{(data.isPreview ? data.sysText.viewEmailDialog_previewTitle : data.sysText.viewEmailDialog_viewTitle) | titlecase}}
	</h6>
	@if (isMobile$ | async) {
		<span class="spacer"></span>
		<button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.sysText.viewEmailDialog_close">
		  <mat-icon class="button-icon">close</mat-icon>
		</button>
	}
</div>

<mat-dialog-content #content>
	<div class="info-section">
		<span class="section-label body2 grey6 semibold">{{data.sysText.viewEmailDialog_from}}:</span>
		<span class="body2 grey3 contact-chip">{{data.emailData.sender?.description}}</span>
	</div>
	<div class="info-section">
		<span class="section-label body2 grey6 semibold">{{data.sysText.viewEmailDialog_to}}:</span>
		<div>
			@for (rec of data.emailData.recipients; track rec; let i = $index) {
				<span class="body2 grey3 contact-chip">
					@if (rec.name?.length > 0) {
						{{rec.name}} &lt;{{rec.email}}&gt;
					} @else {
						{{rec.email}}
					}
				</span>
			}
		</div>
	</div>
	<div class="info-section">
		<span class="section-label body2 grey6 semibold">{{data.sysText.viewEmailDialog_cc}}:</span>
		<div>
			@for (rec of data.emailData.cc; track rec; let i = $index) {
				<span class="body2 grey3 contact-chip">
					@if (rec.name?.length > 0) {
						{{rec.name}} &lt;{{rec.email}}&gt;
					} @else {
						{{rec.email}}
					}
				</span>
			}
		</div>
	</div>
	<div class="info-section">
		<span class="section-label body2 grey6 semibold">{{data.sysText.viewEmailDialog_bcc}}:</span>
		<div>
			@for (rec of data.emailData.bcc; track rec; let i = $index) {
				<span class="body2 grey3 contact-chip">
					@if (rec.name?.length > 0) {
						{{rec.name}} &lt;{{rec.email}}&gt;
					} @else {
						{{rec.email}}
					}
				</span>
			}
		</div>
	</div>
	<div class="flex">
		<mat-icon class="section-label">title</mat-icon>
		<span class="body2 grey6 semibold">{{data.emailData.subject}}</span>
	</div>
	<div class="info-section">
		<mat-icon class="body-icon">subject</mat-icon>
		<div class="editor-container">
			<editor
				#editor
				[(ngModel)]="data.emailData.bodyHtml"
				[init]="{
					width: '100%',
					iframe_aria_text: data.sysText.emailBody,
					menubar: false,
					statusbar: false,
					toolbar: false,
					setup: tinySetup,
					paste_block_drop: true,
					paste_as_text: true,
					promotion: false,
					license_key: tinyMceKey,
					plugins: 'autoresize',
					content_style: editorStyle
				}"
			></editor>
		</div>
	</div>
	<div class="info-section">
		<mat-icon class="section-label">attach_file</mat-icon>
		<div class="attachments-container">
			@if (data.emailData.attachments.length > 0) {
				@for(attachment of data.emailData.attachments; track attachment; let i = $index){
					@let isDownloading = isDownloadingAttachment$ | async;
					<!-- while downloading the title stays focusable (aria-disabled) and the guard blocks clicks; download-link keeps
					the spinner beside it -->
					<span class="download-link">
						<button
							type="button"
							class="button-reset body2 click-link"
							[attr.aria-disabled]="isDownloading || null"
							(click)="!isDownloading && downloadAttachment(attachment)">
							{{attachment.attachmentTitle}}
						</button>
						@if (isDownloading && isDownloadingAttachment(attachment.attachmentId)) {
							<mat-spinner
								class="download-spinner"
								[diameter]="18"
								color="accent">
							</mat-spinner>
						}
					</span>
				}
			} @else {
				<span class="no-attachments">{{data.sysText.viewEmailDialog_noattachments}}</span>
			}
		</div>
	</div>
</mat-dialog-content>

<!-- Close is the only action, so on phones (header X instead) the whole bar goes -->
@if (!(isMobile$ | async)) {
	<mat-dialog-actions align="end">
		<button mat-stroked-button class="button" color="accent" (click)="close()">
			{{data.sysText.viewEmailDialog_close}}
		</button>
	</mat-dialog-actions>
}